import { Inject, Injectable, InjectionToken } from '@angular/core'
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Observable } from 'rxjs'
import { timeout } from 'rxjs/operators'

export const INT_DEFAULT_TIMEOUT = new InjectionToken<number>('intDefaultTimeout')

@Injectable()
export class InterceptorApi implements HttpInterceptor {
  constructor (@Inject(INT_DEFAULT_TIMEOUT) protected intDefaultTimeout: number) {
  }

  intercept (req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const timeoutValue: any = req.headers.get('timeout') || this.intDefaultTimeout

    return next.handle(req).pipe(timeout(Number(timeoutValue)))
  }
}
